const termsSections = [
  {
    "title": "1. Anbieter und Geltungsbereich",
    "paragraphs": [
      "Folder2Zip wird von Mohammad Ghaith Albaba, Einzelunternehmer, Karlstraße 42, 06844 Dessau-Roßlau, Deutschland, E-Mail f2z.business@its-ghaith.com („Anbieter“) bereitgestellt. Diese Bedingungen gelten für Folder2Zip Free und Folder2Zip Plus gegenüber Verbrauchern und Unternehmern."
    ]
  },
  {
    "title": "2. Leistung",
    "paragraphs": [
      "Folder2Zip verarbeitet vom Nutzer ausgewählte Ordner lokal im Browser zu ZIP-Dateien und kann die erzeugte ZIP-Datei an Upload-Felder einer vom Nutzer verwendeten Webseite übergeben. Folder2Zip Plus umfasst zusätzliche Funktionen wie DEFLATE-Komprimierung, ZIP64, Filter, eigene ZIP-Namen und Website-Regeln. Drittwebseiten können synthetische Uploads technisch ablehnen; in diesem Fall kann ein Download-Fallback angeboten werden."
    ]
  },
  {
    "title": "3. Folder2Zip Free",
    "paragraphs": [
      "Die grundlegende lokale ZIP-Funktion kann kostenlos genutzt werden. Datei- und Ordnerinhalte werden dabei grundsätzlich nicht an einen Folder2Zip-Server übertragen."
    ]
  },
  {
    "title": "4. Folder2Zip Plus und Vertragsschluss",
    "paragraphs": [
      "Der Erwerb von Plus wird über eine Stripe-gehostete Checkout-Seite eingeleitet. Stripe Managed Payments fungiert für die Verkaufstransaktion als Merchant of Record und übernimmt insbesondere Zahlungsabwicklung, transaktionsbezogene Belege, bestimmte indirekte Steuerpflichten sowie transaktionsbezogenen Support. Der Anbieter bleibt für das Produkt, dessen Funktionsumfang und produktspezifischen Support verantwortlich.",
      "Der kostenpflichtige Vertrag wird nach dem im Checkout angezeigten Ablauf geschlossen. Vor der Bestellung werden Tarif, Preis, Abrechnungsintervall und wesentliche Vertragsinformationen angezeigt. Plus wird nach erfolgreicher Verifikation des bezahlten Stripe-Abonnements freigeschaltet."
    ]
  },
  {
    "title": "5. Preis und Zahlung",
    "paragraphs": [
      "Maßgeblich ist der unmittelbar vor Bestellung im Stripe Checkout angezeigte Gesamtpreis einschließlich der dort ausgewiesenen Steuern. Zahlungsdaten werden von Stripe verarbeitet; Folder2Zip speichert keine vollständigen Karten- oder Bankdaten."
    ]
  },
  {
    "title": "6. Laufzeit und Kündigung",
    "paragraphs": [
      "Folder2Zip Plus wird als monatlicher Tarif sowie als Tarif mit einer anfänglichen Laufzeit von zwölf Monaten angeboten. Der monatliche Tarif verlängert sich jeweils um einen weiteren Monat, solange er nicht gekündigt wird.",
      "Beim 12-Monats-Tarif werden für die ersten zwölf Monate 32,49 € einschließlich ggf. anfallender indirekter Steuer berechnet. Wird nicht gekündigt, läuft der Vertrag nach Ablauf dieser anfänglichen Laufzeit auf unbestimmte Zeit weiter und wird ab dann monatlich mit 3,49 € einschließlich ggf. anfallender indirekter Steuer abgerechnet.",
      "Eine Kündigung kann jederzeit erklärt werden. Während der anfänglichen 12-Monats-Laufzeit wirkt sie zum Ende dieser bereits bezahlten Laufzeit. Nach dem Übergang in die monatliche Fortsetzung wirkt sie zum Ende der jeweils laufenden bezahlten Monatsperiode.",
      "Die Kündigung kann über die leicht zugängliche Funktion „Verträge hier kündigen“ oder zusätzlich über die Stripe-Aboverwaltung erfolgen. Die Deinstallation der Erweiterung oder das Entfernen der lokalen Aktivierung kündigt das kostenpflichtige Abonnement nicht."
    ]
  },
  {
    "title": "7. Widerruf",
    "paragraphs": [
      "Verbrauchern steht das gesetzliche Widerrufsrecht zu, soweit es nicht nach den gesetzlichen Vorschriften ausgeschlossen oder erloschen ist. Einzelheiten enthält die Widerrufsbelehrung und elektronische Widerrufsfunktion."
    ]
  },
  {
    "title": "8. Kaufwiederherstellung",
    "paragraphs": [
      "Nach einer Neuinstallation kann Plus über die beim Kauf verwendete E-Mail-Adresse wiederhergestellt werden. Hierzu kann Folder2Zip einen zeitlich begrenzten Einmalcode versenden. Nach erfolgreicher Verifikation wird das aktive Abonnement der neuen pseudonymen Installationskennung zugeordnet."
    ]
  },
  {
    "title": "9. Updates und Änderungen",
    "paragraphs": [
      "Gesetzlich erforderliche Aktualisierungen, einschließlich Sicherheitsaktualisierungen, werden im erforderlichen Umfang bereitgestellt. Darüber hinaus kann Folder2Zip aus triftigen Gründen geändert werden, insbesondere zur Anpassung an Browser-Schnittstellen, Sicherheitsanforderungen, Store-Vorgaben oder technische Weiterentwicklungen. Gesetzliche Informations- und Beendigungsrechte bei erheblichen Änderungen bleiben unberührt."
    ]
  },
  {
    "title": "10. Pflichten des Nutzers",
    "paragraphs": [
      "Der Nutzer darf Folder2Zip nur rechtmäßig verwenden und muss zur Verarbeitung und zum Upload der ausgewählten Dateien berechtigt sein. Manipulationen der Plus-Aktivierung, vorsätzliche Überlastung der Infrastruktur und rechtswidrige Umgehung von Schutzmaßnahmen sind untersagt."
    ]
  },
  {
    "title": "11. Gesetzliche Rechte für digitale Produkte",
    "paragraphs": [
      "Die gesetzlichen Rechte bei digitalen Produkten, insbesondere bei Nichtbereitstellung, Mängeln, Aktualisierungen, Nacherfüllung, Minderung, Vertragsbeendigung und Schadensersatz, bleiben uneingeschränkt bestehen."
    ]
  },
  {
    "title": "12. Haftung",
    "paragraphs": [
      "Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei Verletzung von Leben, Körper oder Gesundheit, nach zwingenden gesetzlichen Haftungsvorschriften und im Umfang ausdrücklich übernommener Garantien. Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung auf den typischerweise vorhersehbaren Schaden begrenzt. Im Übrigen ist die Haftung für leichte Fahrlässigkeit ausgeschlossen, soweit gesetzlich zulässig."
    ]
  },
  {
    "title": "13. Datenschutz",
    "paragraphs": [
      "Es gilt die Datenschutzerklärung. Datei- und Ordnerinhalte werden grundsätzlich lokal verarbeitet. Für Plus werden nur die zur Bereitstellung, Prüfung, Wiederherstellung, Kündigung oder zum Widerruf erforderlichen technischen und personenbezogenen Daten verarbeitet."
    ]
  },
  {
    "title": "14. Rechte an der Software",
    "paragraphs": [
      "Der Nutzer erhält das Recht, Folder2Zip und bei aktiver Plus-Berechtigung die Plus-Funktionen bestimmungsgemäß zu nutzen. Für Open-Source-Bestandteile gelten die jeweiligen Lizenzbedingungen vorrangig."
    ]
  },
  {
    "title": "15. Verbraucherschlichtung",
    "paragraphs": [
      "Der Anbieter ist nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen."
    ]
  },
  {
    "title": "16. Recht und Gerichtsstand",
    "paragraphs": [
      "Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Gegenüber Verbrauchern gilt diese Rechtswahl nur, soweit dadurch zwingender Schutz des Staates ihres gewöhnlichen Aufenthalts nicht entzogen wird. Für Verbraucher gelten die gesetzlichen Gerichtsstände."
    ]
  },
  {
    "title": "17. Schlussbestimmungen",
    "paragraphs": [
      "Unwirksame Bestimmungen berühren die Wirksamkeit der übrigen Bedingungen nicht; an ihre Stelle tritt die gesetzliche Regelung. Zwingende Verbraucherrechte bleiben unberührt."
    ]
  }
];

const privacySections = [
  {
    "title": "1. Verantwortlicher",
    "paragraphs": [
      "Mohammad Ghaith Albaba, Einzelunternehmer, Karlstraße 42, 06844 Dessau-Roßlau, Deutschland, Telefon +49 340 87115025, E-Mail f2z.business@its-ghaith.com."
    ]
  },
  {
    "title": "2. Lokale Datei- und Ordnerverarbeitung",
    "paragraphs": [
      "Folder2Zip verarbeitet Ordner und Dateien, die der Nutzer ausdrücklich auswählt oder auf eine Webseite zieht, grundsätzlich lokal im Browser. Inhalte und Dateinamen werden nicht an den Folder2Zip-Plus-Server übertragen. Die Erweiterung verwendet keine eigene Analyse- oder Werbetelemetrie."
    ]
  },
  {
    "title": "3. Lokale Speicherung",
    "paragraphs": [
      "Im lokalen Erweiterungsspeicher können Einstellungen, eine pseudonyme Installationskennung, Checkout-/Restore-Zwischenstände, ein signiertes Plus-Entitlement, Plan- und Statusinformationen sowie der Zeitpunkt der letzten Prüfung gespeichert werden. Diese Daten dienen der Bereitstellung der vom Nutzer angeforderten Funktionen."
    ]
  },
  {
    "title": "4. Plus, Stripe und Vertragsdaten",
    "paragraphs": [
      "Beim Kauf, bei Aktivierung, Statusprüfung, Wiederherstellung und Aboverwaltung werden die hierfür erforderlichen Identifikatoren an den Folder2Zip-Plus-Server übertragen. Dieser kommuniziert serverseitig mit Stripe. Stripe Managed Payments verarbeitet Zahlungs- und Transaktionsdaten als Merchant of Record. Rechtsgrundlage für die zur Vertragsdurchführung erforderliche Verarbeitung ist Art. 6 Abs. 1 lit. b DSGVO; soweit rechtliche Pflichten bestehen, Art. 6 Abs. 1 lit. c DSGVO."
    ]
  },
  {
    "title": "5. Kaufwiederherstellung und E-Mail-Versand",
    "paragraphs": [
      "Bei einer Kaufwiederherstellung wird die eingegebene Kauf-E-Mail-Adresse verwendet, um ein passendes aktives Stripe-Abonnement zu suchen und einen kurzlebigen Einmalcode zu versenden. Der Versand erfolgt über Amazon SES. Die E-Mail-Adresse wird dabei nicht als eigene Folder2Zip-Kundendatenbank gespeichert."
    ]
  },
  {
    "title": "6. Kündigung und Widerruf",
    "paragraphs": [
      "Bei Nutzung der elektronischen Kündigungs- oder Widerrufsfunktion werden die vom Nutzer eingegebenen Identifikations-, Vertrags- und Kommunikationsdaten verarbeitet, um die Erklärung entgegenzunehmen, zu bearbeiten und eine elektronische Eingangsbestätigung zu versenden. Die Verarbeitung erfolgt zur Vertragsabwicklung und Erfüllung gesetzlicher Pflichten."
    ]
  },
  {
    "title": "7. Hosting und Empfänger",
    "paragraphs": [
      "Der Plus-Dienst wird auf AWS-Infrastruktur betrieben; der derzeitige Backend-Standort liegt in der EU-Region Frankfurt. Für E-Mail-Versand wird Amazon SES eingesetzt. Zahlungs- und Abonnementdaten werden an Stripe übermittelt. Soweit Anbieter Daten außerhalb des EWR verarbeiten, gelten deren jeweils anwendbare Datenschutzgarantien und Übermittlungsmechanismen."
    ]
  },
  {
    "title": "8. Protokolldaten",
    "paragraphs": [
      "Hosting- und Sicherheitsinfrastruktur kann technische Protokolldaten wie Zeitpunkt, aufgerufenen Endpunkt, Statuscode und netzwerkbezogene Metadaten erzeugen. Diese Daten werden nur für Betrieb, Fehleranalyse, Sicherheit und Missbrauchsschutz verwendet und nach den konfigurierten Aufbewahrungsfristen gelöscht."
    ]
  },
  {
    "title": "9. Speicherdauer",
    "paragraphs": [
      "Lokale Erweiterungsdaten bleiben grundsätzlich bis zur Löschung durch den Nutzer oder Deinstallation bestehen. Backend-Daten werden nur so lange verarbeitet, wie dies für die jeweilige Anfrage, Vertragsabwicklung, Sicherheitszwecke oder gesetzliche Aufbewahrungspflichten erforderlich ist. Stripe und AWS wenden daneben ihre eigenen gesetzlich bzw. vertraglich bestimmten Aufbewahrungsfristen an."
    ]
  },
  {
    "title": "10. Betroffenenrechte",
    "paragraphs": [
      "Betroffene haben nach Maßgabe der DSGVO insbesondere Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Besteht eine Einwilligung, kann sie mit Wirkung für die Zukunft widerrufen werden. Außerdem besteht das Recht auf Beschwerde bei einer zuständigen Datenschutzaufsichtsbehörde."
    ]
  },
  {
    "title": "11. Kontakt",
    "paragraphs": [
      "Datenschutzanfragen können an f2z.business@its-ghaith.com gerichtet werden."
    ]
  }
];

export { termsSections, privacySections };
